import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T;
export type InputMaybe<T> = T;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Upload: { input: any; output: any; }
};

export type Aggregation = {
  __typename?: 'Aggregation';
  label: Scalars['String']['output'];
  options: Array<AggregationOption>;
  value: Scalars['String']['output'];
};

export type AggregationInput = {
  options: Array<Scalars['String']['input']>;
  value: Scalars['String']['input'];
};

export type AggregationOption = {
  __typename?: 'AggregationOption';
  count: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type Asset = {
  __typename?: 'Asset';
  filename: Scalars['String']['output'];
  fullpath: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type AttributeDescription = {
  __typename?: 'AttributeDescription';
  attributeCode: Scalars['String']['output'];
  children: Array<Children>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  parent?: Maybe<Parent>;
  parentId: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type AttributeDescriptionConnection = {
  __typename?: 'AttributeDescriptionConnection';
  /** Edges of the connection */
  edges?: Maybe<Array<AttributeDescriptionEdge>>;
  /** Page info of the connection */
  pageInfo?: Maybe<PageInfo>;
  /** Total count of items in the connection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AttributeDescriptionEdge = {
  __typename?: 'AttributeDescriptionEdge';
  /** The edge cursor */
  cursor: Scalars['String']['output'];
  /** Node of the Edge */
  node: AttributeDescription;
};

export type BlogCategory = {
  __typename?: 'BlogCategory';
  children: Array<Children>;
  customUrlKey?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['String']['output']>;
  hreflang: Array<Hreflang>;
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaKeywords?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<Parent>;
  parentId: Scalars['ID']['output'];
  showInMenu: Scalars['Boolean']['output'];
  url?: Maybe<Scalars['String']['output']>;
  urlIdentifier: Scalars['String']['output'];
  urlKey?: Maybe<Scalars['String']['output']>;
};

export type BlogCategoryConnection = {
  __typename?: 'BlogCategoryConnection';
  /** Edges of the connection */
  edges?: Maybe<Array<BlogCategoryEdge>>;
  /** Page info of the connection */
  pageInfo?: Maybe<PageInfo>;
  /** Total count of items in the connection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type BlogCategoryEdge = {
  __typename?: 'BlogCategoryEdge';
  /** The edge cursor */
  cursor: Scalars['String']['output'];
  /** Node of the Edge */
  node: BlogCategory;
};

export type Category = {
  __typename?: 'Category';
  blocks: Array<CategorySeoBlock>;
  children: Array<Children>;
  description?: Maybe<Scalars['String']['output']>;
  displayType?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  hreflang: Array<Hreflang>;
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
  isUsedForSeo?: Maybe<Scalars['String']['output']>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaKeywords?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<Parent>;
  parentId: Scalars['ID']['output'];
  showFilters: Scalars['Boolean']['output'];
  url?: Maybe<Scalars['String']['output']>;
  urlIdentifier: Scalars['String']['output'];
  urlKey?: Maybe<Scalars['String']['output']>;
};

export type CategorySeoBlock = {
  __typename?: 'CategorySeoBlock';
  content?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type Children = BlogCategory | Category | DiyProject | FaqCategory | FaqItem | Page | Product | Sheet | Stylist;

export type DiyProject = {
  __typename?: 'DIYProject';
  active: Scalars['Boolean']['output'];
  baseLanguage?: Maybe<Scalars['String']['output']>;
  cartHash?: Maybe<Scalars['String']['output']>;
  categoryBrands: Array<BlogCategory>;
  children: Array<Children>;
  colorCode?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  customUrlKey?: Maybe<Scalars['String']['output']>;
  deliveryStars?: Maybe<Scalars['Float']['output']>;
  diyType: Array<BlogCategory>;
  endProducts: Array<BlogCategory>;
  famousDesigners: Array<BlogCategory>;
  firstname?: Maybe<Scalars['String']['output']>;
  generalStars?: Maybe<Scalars['Float']['output']>;
  hasRestpieces: Scalars['Boolean']['output'];
  highlightable: Scalars['Boolean']['output'];
  hreflang: Array<Hreflang>;
  id: Scalars['ID']['output'];
  images: Array<Image>;
  isSalable: Scalars['Boolean']['output'];
  keywords?: Maybe<Scalars['String']['output']>;
  knownFrom: Array<BlogCategory>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaKeywords?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  orderStars?: Maybe<Scalars['Float']['output']>;
  parent?: Maybe<Parent>;
  parentId: Scalars['ID']['output'];
  price?: Maybe<Scalars['Float']['output']>;
  products: Array<Product>;
  projectCode?: Maybe<Scalars['String']['output']>;
  projectLevel?: Maybe<Scalars['Float']['output']>;
  review?: Maybe<Scalars['String']['output']>;
  shippingPrice?: Maybe<Scalars['Float']['output']>;
  shortUrl: Array<ShortUrl>;
  spaces: Array<BlogCategory>;
  status?: Maybe<Scalars['String']['output']>;
  stepByStepGuide: Array<StepByStepGuide>;
  styles: Array<BlogCategory>;
  tips?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  translated: Scalars['Boolean']['output'];
  url?: Maybe<Scalars['String']['output']>;
  urlIdentifier?: Maybe<Scalars['String']['output']>;
  urlKey?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
  woodCategories: Array<Category>;
  woodTypes: Array<BlogCategory>;
  wordpressPostId?: Maybe<Scalars['String']['output']>;
};

export type DiyProjectConnection = {
  __typename?: 'DIYProjectConnection';
  /** Edges of the connection */
  edges?: Maybe<Array<DiyProjectEdge>>;
  /** Page info of the connection */
  pageInfo?: Maybe<PageInfo>;
  /** Total count of items in the connection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type DiyProjectEdge = {
  __typename?: 'DIYProjectEdge';
  /** The edge cursor */
  cursor: Scalars['String']['output'];
  /** Node of the Edge */
  node: DiyProject;
};

export type DiyProjectIndex = {
  __typename?: 'DIYProjectIndex';
  aggregations: Array<Aggregation>;
  connection: DiyProjectConnection;
};

export type EdgeBand = {
  __typename?: 'EdgeBand';
  articleId?: Maybe<Scalars['String']['output']>;
  children: Array<Children>;
  color?: Maybe<Scalars['String']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  cuttable: Scalars['Boolean']['output'];
  decor?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  fixedPrice?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
  margin?: Maybe<Scalars['Float']['output']>;
  material?: Maybe<Scalars['String']['output']>;
  minOrderLength?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<Parent>;
  parentId: Scalars['ID']['output'];
  price?: Maybe<Scalars['String']['output']>;
  priceType?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  productType: Scalars['String']['output'];
  sku: Scalars['String']['output'];
  stockPosition?: Maybe<Scalars['String']['output']>;
  surface?: Maybe<Scalars['String']['output']>;
  taxClass?: Maybe<Tax>;
  thickness?: Maybe<Scalars['Float']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type ElementMetaDataSpecsheet = {
  __typename?: 'ElementMetaDataSpecsheet';
  element?: Maybe<Asset>;
  variant?: Maybe<Scalars['String']['output']>;
};

export type FaqCategory = {
  __typename?: 'FaqCategory';
  children: Array<Children>;
  enabled: Scalars['Boolean']['output'];
  faqItems: Array<FaqItem>;
  id: Scalars['ID']['output'];
  parent?: Maybe<Parent>;
  parentId: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type FaqCategoryConnection = {
  __typename?: 'FaqCategoryConnection';
  /** Edges of the connection */
  edges?: Maybe<Array<FaqCategoryEdge>>;
  /** Page info of the connection */
  pageInfo?: Maybe<PageInfo>;
  /** Total count of items in the connection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type FaqCategoryEdge = {
  __typename?: 'FaqCategoryEdge';
  /** The edge cursor */
  cursor: Scalars['String']['output'];
  /** Node of the Edge */
  node: FaqCategory;
};

export type FaqItem = {
  __typename?: 'FaqItem';
  children: Array<Children>;
  content?: Maybe<Scalars['String']['output']>;
  customUrlKey?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  hreflang: Array<Hreflang>;
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
  imagePosition?: Maybe<Scalars['String']['output']>;
  imageSize?: Maybe<Scalars['String']['output']>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<Parent>;
  parentId: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  urlIdentifier?: Maybe<Scalars['String']['output']>;
  urlKey?: Maybe<Scalars['String']['output']>;
};

export type FaqItemConnection = {
  __typename?: 'FaqItemConnection';
  /** Edges of the connection */
  edges?: Maybe<Array<FaqItemEdge>>;
  /** Page info of the connection */
  pageInfo?: Maybe<PageInfo>;
  /** Total count of items in the connection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type FaqItemEdge = {
  __typename?: 'FaqItemEdge';
  /** The edge cursor */
  cursor: Scalars['String']['output'];
  /** Node of the Edge */
  node: FaqItem;
};

export type Finish = {
  __typename?: 'Finish';
  categoryUrl?: Maybe<Scalars['String']['output']>;
  children: Array<Children>;
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disallowedShapes: Array<Shape>;
  id: Scalars['ID']['output'];
  image2d?: Maybe<Image>;
  image3d?: Maybe<Image>;
  name?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<Parent>;
  parentId: Scalars['ID']['output'];
  price?: Maybe<Scalars['Float']['output']>;
  shapeEnabled: Scalars['Boolean']['output'];
};

export type FrontendMutation = {
  __typename?: 'FrontendMutation';
  submitAIProject: SubmitAiProjectResult;
};


export type FrontendMutationSubmitAiProjectArgs = {
  input: SubmitAiProjectInput;
};

export type FrontendQuery = {
  __typename?: 'FrontendQuery';
  DIYProjectForm?: Maybe<DiyProject>;
  edgeBandQuery?: Maybe<PublicEdgeBand>;
  edgeBandsQuery: PublicEdgeBandIndexType;
  getAttributeDescription?: Maybe<AttributeDescription>;
  getAttributeDescriptionListing: AttributeDescriptionConnection;
  getBlogCategory?: Maybe<BlogCategory>;
  getBlogCategoryListing: BlogCategoryConnection;
  getDIYProject?: Maybe<DiyProject>;
  getDIYProjectIndexListing: DiyProjectIndex;
  getDIYProjectListing: DiyProjectConnection;
  getFaqCategory?: Maybe<FaqCategory>;
  getFaqCategoryListing: FaqCategoryConnection;
  getFaqItem?: Maybe<FaqItem>;
  getFaqItemListing: FaqItemConnection;
  getPage?: Maybe<Page>;
  getPageListing: PageConnection;
  getStylist?: Maybe<Stylist>;
  getStylistListing: StylistConnection;
  miniSearch: Array<Index>;
  ping: Scalars['String']['output'];
  relatedDiyProjects: DiyProjectConnection;
};


export type FrontendQueryDiyProjectFormArgs = {
  hash: Scalars['String']['input'];
};


export type FrontendQueryEdgeBandQueryArgs = {
  defaultLanguage: Scalars['String']['input'];
  sku: Scalars['String']['input'];
};


export type FrontendQueryEdgeBandsQueryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  defaultLanguage: Scalars['String']['input'];
  filter?: InputMaybe<Array<AggregationInput>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sku: Scalars['String']['input'];
};


export type FrontendQueryGetAttributeDescriptionArgs = {
  defaultLanguage: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type FrontendQueryGetAttributeDescriptionListingArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  defaultLanguage: Scalars['String']['input'];
  filter?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type FrontendQueryGetBlogCategoryArgs = {
  defaultLanguage: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type FrontendQueryGetBlogCategoryListingArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  defaultLanguage: Scalars['String']['input'];
  filter?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type FrontendQueryGetDiyProjectArgs = {
  defaultLanguage: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type FrontendQueryGetDiyProjectIndexListingArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['ID']['input']>;
  defaultLanguage: Scalars['String']['input'];
  filter?: InputMaybe<Array<AggregationInput>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type FrontendQueryGetDiyProjectListingArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  defaultLanguage: Scalars['String']['input'];
  filter?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type FrontendQueryGetFaqCategoryArgs = {
  defaultLanguage: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type FrontendQueryGetFaqCategoryListingArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  defaultLanguage: Scalars['String']['input'];
  filter?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type FrontendQueryGetFaqItemArgs = {
  defaultLanguage: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type FrontendQueryGetFaqItemListingArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  defaultLanguage: Scalars['String']['input'];
  filter?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type FrontendQueryGetPageArgs = {
  defaultLanguage: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type FrontendQueryGetPageListingArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  defaultLanguage: Scalars['String']['input'];
  filter?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type FrontendQueryGetStylistArgs = {
  defaultLanguage: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type FrontendQueryGetStylistListingArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  defaultLanguage: Scalars['String']['input'];
  filter?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type FrontendQueryMiniSearchArgs = {
  defaultLanguage: Scalars['String']['input'];
  query: Scalars['String']['input'];
};


export type FrontendQueryPingArgs = {
  message: Scalars['String']['input'];
};


export type FrontendQueryRelatedDiyProjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  defaultLanguage: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sku: Scalars['String']['input'];
};

export type Hreflang = {
  __typename?: 'Hreflang';
  href: Scalars['String']['output'];
  hreflang: Scalars['String']['output'];
};

export type Image = {
  __typename?: 'Image';
  filename: Scalars['String']['output'];
  fullpath: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type Index = {
  __typename?: 'Index';
  code: Scalars['String']['output'];
  items: Array<Children>;
  name: Scalars['String']['output'];
};

export type Link = {
  __typename?: 'Link';
  accessKey?: Maybe<Scalars['String']['output']>;
  anchor: Scalars['String']['output'];
  attributes?: Maybe<Scalars['String']['output']>;
  class?: Maybe<Scalars['String']['output']>;
  href: Scalars['String']['output'];
  html: Scalars['String']['output'];
  path: Scalars['String']['output'];
  rel?: Maybe<Scalars['String']['output']>;
  tabindex?: Maybe<Scalars['String']['output']>;
  target?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type Page = {
  __typename?: 'Page';
  blogCategory?: Maybe<BlogCategory>;
  children: Array<Children>;
  content?: Maybe<Scalars['String']['output']>;
  customUrlKey?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['String']['output']>;
  hreflang: Array<Hreflang>;
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
  includeInSitemap?: Maybe<Scalars['String']['output']>;
  intro?: Maybe<Scalars['String']['output']>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  pageRelation: Array<PageRelationUnion>;
  pageType?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<Parent>;
  parentId: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  urlIdentifier: Scalars['String']['output'];
  urlKey?: Maybe<Scalars['String']['output']>;
};

export type PageConnection = {
  __typename?: 'PageConnection';
  /** Edges of the connection */
  edges?: Maybe<Array<PageEdge>>;
  /** Page info of the connection */
  pageInfo?: Maybe<PageInfo>;
  /** Total count of items in the connection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PageEdge = {
  __typename?: 'PageEdge';
  /** The edge cursor */
  cursor: Scalars['String']['output'];
  /** Node of the Edge */
  node: Page;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type Parent = Category | FaqCategory | FaqItem | Page | Product | Stylist;

export type Product = {
  __typename?: 'Product';
  accessoriesBitType?: Maybe<Scalars['String']['output']>;
  accessoriesColorCode?: Maybe<Scalars['String']['output']>;
  accessoriesDiameter?: Maybe<Scalars['String']['output']>;
  accessoriesHeight?: Maybe<Scalars['Float']['output']>;
  accessoriesLength?: Maybe<Scalars['Float']['output']>;
  accessoriesPackagingContent?: Maybe<Scalars['Float']['output']>;
  accessoriesWidth?: Maybe<Scalars['Float']['output']>;
  alternativeProduct?: Maybe<Product>;
  attributeSet: Scalars['String']['output'];
  brand?: Maybe<Scalars['String']['output']>;
  cabinetOuterDepth?: Maybe<Scalars['String']['output']>;
  cabinetOuterHeight?: Maybe<Scalars['String']['output']>;
  cabinetOuterWidth?: Maybe<Scalars['String']['output']>;
  calculatedPrice?: Maybe<Scalars['String']['output']>;
  categories: Array<Category>;
  categoryLabel?: Maybe<Scalars['String']['output']>;
  children: Array<Children>;
  color?: Maybe<Scalars['String']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  crossSells: Array<Product>;
  customJsonConfiguration?: Maybe<Scalars['String']['output']>;
  customUrlKey?: Maybe<Scalars['String']['output']>;
  deliveryOffset?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  detailImage?: Maybe<Image>;
  diyProjectCode?: Maybe<Scalars['String']['output']>;
  ean?: Maybe<Scalars['String']['output']>;
  edgeBands: Array<EdgeBand>;
  faqCategories: Array<FaqCategory>;
  fixedPrice?: Maybe<Scalars['Float']['output']>;
  gallery: Array<Image>;
  hreflang: Array<Hreflang>;
  hsCode?: Maybe<Scalars['Float']['output']>;
  hsCodeUnit?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
  isInStock: Scalars['Boolean']['output'];
  margin?: Maybe<Scalars['Float']['output']>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaKeywords?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  minimalPrice?: Maybe<Scalars['Float']['output']>;
  minimalPriceCompletePanel?: Maybe<Scalars['Float']['output']>;
  minimalPriceThreshold?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<Parent>;
  parentId: Scalars['ID']['output'];
  plasticAcrylaatType?: Maybe<Scalars['String']['output']>;
  plasticBreakdownVoltage?: Maybe<Scalars['String']['output']>;
  plasticBuigsterkteNewtonMm2?: Maybe<Scalars['Float']['output']>;
  plasticCompresResistanceNewtonMm2?: Maybe<Scalars['Float']['output']>;
  plasticDensityGrCm3?: Maybe<Scalars['Float']['output']>;
  plasticDielectricLossFactor?: Maybe<Scalars['String']['output']>;
  plasticElasticyModulusNewtonMm2?: Maybe<Scalars['Float']['output']>;
  plasticFrictionCoefficient?: Maybe<Scalars['Float']['output']>;
  plasticHardnessShore?: Maybe<Scalars['String']['output']>;
  plasticLightTransmission?: Maybe<Scalars['String']['output']>;
  plasticLinearExpansionCoefficient?: Maybe<Scalars['Float']['output']>;
  plasticRelativeDielectricConstant?: Maybe<Scalars['String']['output']>;
  plasticResistanceSpecific?: Maybe<Scalars['String']['output']>;
  plasticResistanceSurface?: Maybe<Scalars['String']['output']>;
  plasticSoundDamping?: Maybe<Scalars['Float']['output']>;
  plasticTemperatureMaxUnloaded?: Maybe<Scalars['Float']['output']>;
  plasticTemperatureMinUnloaded?: Maybe<Scalars['Float']['output']>;
  plasticTensileNewtonMm2?: Maybe<Scalars['Float']['output']>;
  plasticUvResistant?: Maybe<Scalars['String']['output']>;
  plasticWarranty?: Maybe<Scalars['String']['output']>;
  priceType?: Maybe<Scalars['String']['output']>;
  quantityIncrements?: Maybe<Scalars['Float']['output']>;
  relatedProducts: Array<Product>;
  sample?: Maybe<Product>;
  sampleService?: Maybe<Scalars['String']['output']>;
  sheetAlternativeOptiplanning?: Maybe<Scalars['String']['output']>;
  sheetAppearance?: Maybe<Scalars['String']['output']>;
  sheetApplyBeltSize?: Maybe<Scalars['String']['output']>;
  sheetAvailableAbsBandColors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sheetColorCode?: Maybe<Scalars['String']['output']>;
  sheetColorShade?: Maybe<Scalars['String']['output']>;
  sheetConditionAgreement?: Maybe<Scalars['String']['output']>;
  sheetConditionAgreementText?: Maybe<Scalars['String']['output']>;
  sheetConnectionType?: Maybe<Scalars['String']['output']>;
  sheetCore?: Maybe<Scalars['String']['output']>;
  sheetDecorative?: Maybe<Scalars['String']['output']>;
  sheetDeliveryTime?: Maybe<Scalars['String']['output']>;
  sheetDensity?: Maybe<Scalars['String']['output']>;
  sheetExcludeForCncProduction?: Maybe<Scalars['String']['output']>;
  sheetFingerprintProof: Scalars['Boolean']['output'];
  sheetFinishes: Array<Finish>;
  sheetFireResistant?: Maybe<Scalars['String']['output']>;
  sheetFormaldehydeReleaseClass?: Maybe<Scalars['String']['output']>;
  sheetGeneralApplication?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sheetGlue?: Maybe<Scalars['String']['output']>;
  sheetGrainType?: Maybe<Scalars['String']['output']>;
  sheetHasVisibleSide: Scalars['Boolean']['output'];
  sheetJointingTechnique?: Maybe<Scalars['String']['output']>;
  sheetMandatoryFinishes: Array<Finish>;
  sheetMaximimumHollowProfile?: Maybe<Scalars['Float']['output']>;
  sheetMaximumChamfering?: Maybe<Scalars['Float']['output']>;
  sheetMaximumCompletion?: Maybe<Scalars['Float']['output']>;
  sheetMaximumMiter?: Maybe<Scalars['Float']['output']>;
  sheetMaximumQuarterRound?: Maybe<Scalars['Float']['output']>;
  sheetMinLength?: Maybe<Scalars['Float']['output']>;
  sheetMinWidth?: Maybe<Scalars['Float']['output']>;
  sheetMinimumChamfering?: Maybe<Scalars['Float']['output']>;
  sheetMinimumCompletion?: Maybe<Scalars['Float']['output']>;
  sheetMinimumHollowprofile?: Maybe<Scalars['Float']['output']>;
  sheetMinimumMiter?: Maybe<Scalars['Float']['output']>;
  sheetMinimumQuarterRound?: Maybe<Scalars['Float']['output']>;
  sheetNcsColorCode?: Maybe<Scalars['String']['output']>;
  sheetOutdoor?: Maybe<Scalars['String']['output']>;
  sheetPaintability?: Maybe<Scalars['String']['output']>;
  sheetPositiveNegative?: Maybe<Scalars['String']['output']>;
  sheetPreMill: Scalars['Boolean']['output'];
  sheetPrimed: Scalars['Boolean']['output'];
  sheetProductionType?: Maybe<Scalars['String']['output']>;
  sheetProductionUnit?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sheetPurchaseType?: Maybe<Scalars['String']['output']>;
  sheetQualityVisual?: Maybe<Scalars['String']['output']>;
  sheetReverseMillingDirection: Scalars['Boolean']['output'];
  sheetShapes: Array<Shape>;
  sheetSustainability?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sheetThickness?: Maybe<Scalars['Float']['output']>;
  sheetToplayerSides?: Maybe<Scalars['String']['output']>;
  sheetToplayerType?: Maybe<Scalars['String']['output']>;
  sheetTreatmentForUse?: Maybe<Scalars['String']['output']>;
  sheetTroughMill: Scalars['Boolean']['output'];
  sheetTypeBase?: Maybe<Scalars['String']['output']>;
  sheetTypeFinish?: Maybe<Scalars['String']['output']>;
  sheetUnit?: Maybe<Scalars['String']['output']>;
  sheetVeneerCuttingMethod?: Maybe<Scalars['String']['output']>;
  sheetVeneerThickness?: Maybe<Scalars['Float']['output']>;
  sheetWaterResistant: Scalars['Boolean']['output'];
  sheetWeightPerM3?: Maybe<Scalars['Float']['output']>;
  sheetWoodApplications?: Maybe<Scalars['String']['output']>;
  sheetWoodQualityMark?: Maybe<Scalars['String']['output']>;
  sheetWoodStructure?: Maybe<Scalars['String']['output']>;
  sheetWoodUsed?: Maybe<Scalars['String']['output']>;
  sheetWorkSpeed?: Maybe<Scalars['String']['output']>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  sku: Scalars['String']['output'];
  specsheet: Array<ElementMetaDataSpecsheet>;
  status?: Maybe<Scalars['String']['output']>;
  stockMessage?: Maybe<Scalars['String']['output']>;
  stockPosition?: Maybe<Scalars['String']['output']>;
  supplier?: Maybe<Scalars['String']['output']>;
  supplierSku?: Maybe<Scalars['String']['output']>;
  taxClass?: Maybe<Tax>;
  threedimensionalSideTexture?: Maybe<Image>;
  threedimensionalTopTexture?: Maybe<Image>;
  tosizeFurnitureDecor?: Maybe<Scalars['String']['output']>;
  typeId: Scalars['String']['output'];
  upSells: Array<Product>;
  url?: Maybe<Scalars['String']['output']>;
  urlIdentifier?: Maybe<Scalars['String']['output']>;
  urlkey?: Maybe<Scalars['String']['output']>;
  visibility?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
  weightFee?: Maybe<Scalars['Float']['output']>;
  youtubeUrl?: Maybe<Scalars['String']['output']>;
  yukiLedgerAccount?: Maybe<Scalars['String']['output']>;
};

export type PublicEdgeBand = {
  __typename?: 'PublicEdgeBand';
  children: Array<Children>;
  color?: Maybe<Scalars['String']['output']>;
  cuttable?: Maybe<Scalars['Boolean']['output']>;
  decor?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
  material?: Maybe<Scalars['String']['output']>;
  minOrderLength?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<Parent>;
  parentId: Scalars['ID']['output'];
  price?: Maybe<Scalars['String']['output']>;
  sku: Scalars['String']['output'];
  surface?: Maybe<Scalars['String']['output']>;
  thickness?: Maybe<Scalars['Float']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type PublicEdgeBandConnection = {
  __typename?: 'PublicEdgeBandConnection';
  edges?: Maybe<Array<PublicEdgeBandEdge>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PublicEdgeBandEdge = {
  __typename?: 'PublicEdgeBandEdge';
  cursor: Scalars['String']['output'];
  node: PublicEdgeBand;
};

export type PublicEdgeBandIndexType = {
  __typename?: 'PublicEdgeBandIndexType';
  aggregations: Array<Aggregation>;
  available: PublicEdgeBandConnection;
  matching: Array<PublicEdgeBand>;
};

export type Shape = {
  __typename?: 'Shape';
  categoryUrl?: Maybe<Scalars['String']['output']>;
  children: Array<Children>;
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  image2d?: Maybe<Image>;
  image3d?: Maybe<Image>;
  maxLength?: Maybe<Scalars['Float']['output']>;
  maxWidth?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<Parent>;
  parentId: Scalars['ID']['output'];
  price: Scalars['Float']['output'];
  sortOrder?: Maybe<Scalars['Float']['output']>;
};

export type Sheet = {
  __typename?: 'Sheet';
  brand?: Maybe<Scalars['String']['output']>;
  calculatedPrice?: Maybe<Scalars['String']['output']>;
  calculatedPriceM2CompletePanel?: Maybe<Scalars['String']['output']>;
  children: Array<Children>;
  cost?: Maybe<Scalars['Float']['output']>;
  deliveryOffset?: Maybe<Scalars['Float']['output']>;
  fixedPrice?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
  length: Scalars['Float']['output'];
  manufacturerProductUrl?: Maybe<Scalars['String']['output']>;
  margin?: Maybe<Scalars['Float']['output']>;
  marginCompletePanel?: Maybe<Scalars['Float']['output']>;
  parent?: Maybe<Parent>;
  parentId: Scalars['ID']['output'];
  priceType?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Product>;
  productionUnit?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  stockPosition?: Maybe<Scalars['String']['output']>;
  supplier?: Maybe<Scalars['String']['output']>;
  supplierProductName?: Maybe<Scalars['String']['output']>;
  supplierProductUrl?: Maybe<Scalars['String']['output']>;
  supplierSku?: Maybe<Scalars['String']['output']>;
  taxClass?: Maybe<Tax>;
  thickness?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
  weightFee?: Maybe<Scalars['Float']['output']>;
  width: Scalars['Float']['output'];
};

export type ShortUrl = {
  __typename?: 'ShortUrl';
  children: Array<Children>;
  id: Scalars['ID']['output'];
  parent?: Maybe<Parent>;
  parentId: Scalars['ID']['output'];
};

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StepByStepGuide = {
  __typename?: 'StepByStepGuide';
  phase?: Maybe<Scalars['String']['output']>;
  stepDescription?: Maybe<Scalars['String']['output']>;
};

export type StepByStepGuideInput = {
  phase: Scalars['String']['input'];
  stepDescription: Scalars['String']['input'];
};

export type Stylist = {
  __typename?: 'Stylist';
  children: Array<Children>;
  companyName?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  customUrlKey?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['String']['output']>;
  facebook?: Maybe<Scalars['String']['output']>;
  formContent?: Maybe<Scalars['String']['output']>;
  formTitle?: Maybe<Scalars['String']['output']>;
  gallery: Array<Image>;
  hreflang: Array<Hreflang>;
  id: Scalars['ID']['output'];
  instagram?: Maybe<Scalars['String']['output']>;
  latlng?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaKeywords?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<Parent>;
  parentId: Scalars['ID']['output'];
  personalImage?: Maybe<Image>;
  personalImageClose?: Maybe<Image>;
  personalTitle?: Maybe<Scalars['String']['output']>;
  pinterest?: Maybe<Scalars['String']['output']>;
  speciality?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  urlKey?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Link>;
  youtube?: Maybe<Scalars['String']['output']>;
};

export type StylistConnection = {
  __typename?: 'StylistConnection';
  /** Edges of the connection */
  edges?: Maybe<Array<StylistEdge>>;
  /** Page info of the connection */
  pageInfo?: Maybe<PageInfo>;
  /** Total count of items in the connection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type StylistEdge = {
  __typename?: 'StylistEdge';
  /** The edge cursor */
  cursor: Scalars['String']['output'];
  /** Node of the Edge */
  node: Stylist;
};

export type SubmitAiProjectInput = {
  colorCode?: InputMaybe<Scalars['String']['input']>;
  deliveryStars?: InputMaybe<Scalars['Int']['input']>;
  firstname: Scalars['String']['input'];
  generalStars?: InputMaybe<Scalars['Int']['input']>;
  hash: Scalars['String']['input'];
  images: Array<Scalars['Upload']['input']>;
  keywords: Array<Scalars['String']['input']>;
  level: Scalars['Int']['input'];
  orderStars?: InputMaybe<Scalars['Int']['input']>;
  review?: InputMaybe<Scalars['String']['input']>;
  stepByStepGuide?: InputMaybe<Array<StepByStepGuideInput>>;
  tips?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitAiProjectResult = {
  __typename?: 'SubmitAIProjectResult';
  project: DiyProject;
};

export type Tax = {
  __typename?: 'Tax';
  children: Array<Children>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parent?: Maybe<Parent>;
  parentId: Scalars['ID']['output'];
  percentage?: Maybe<Scalars['Float']['output']>;
};

export type PageRelationUnion = FaqCategory | FaqItem | Page;

export type SubmitAiProjectMutationMutationVariables = Exact<{
  input: SubmitAiProjectInput;
}>;


export type SubmitAiProjectMutationMutation = (
  { __typename?: 'FrontendMutation' }
  & { submitAIProject: (
    { __typename?: 'SubmitAIProjectResult' }
    & { project: (
      { __typename?: 'DIYProject' }
      & Pick<DiyProject, 'id'>
    ) }
  ) }
);

export type RelatedDiyProjectsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sku: Scalars['String']['input'];
  defaultLanguage: Scalars['String']['input'];
}>;


export type RelatedDiyProjectsQuery = (
  { __typename?: 'FrontendQuery' }
  & { relatedDiyProjects: (
    { __typename?: 'DIYProjectConnection' }
    & { edges?: Maybe<Array<(
      { __typename?: 'DIYProjectEdge' }
      & { node: (
        { __typename?: 'DIYProject' }
        & Pick<DiyProject, 'id' | 'title' | 'url' | 'metaDescription'>
        & { images: Array<(
          { __typename?: 'Image' }
          & Pick<Image, 'id' | 'filename' | 'fullpath'>
        )> }
      ) }
    )>> }
  ) }
);

export type MiniSearchQueryVariables = Exact<{
  query: Scalars['String']['input'];
  defaultLanguage: Scalars['String']['input'];
}>;


export type MiniSearchQuery = (
  { __typename?: 'FrontendQuery' }
  & { miniSearch: Array<(
    { __typename?: 'Index' }
    & Pick<Index, 'name' | 'code'>
    & { items: Array<{ __typename?: 'BlogCategory' } | (
      { __typename?: 'Category' }
      & Pick<Category, 'id' | 'name' | 'url'>
      & { image?: Maybe<(
        { __typename?: 'Image' }
        & Pick<Image, 'id' | 'filename' | 'fullpath'>
      )> }
    ) | (
      { __typename?: 'DIYProject' }
      & Pick<DiyProject, 'id' | 'title' | 'url'>
      & { images: Array<(
        { __typename?: 'Image' }
        & Pick<Image, 'id' | 'filename' | 'fullpath'>
      )> }
    ) | { __typename?: 'FaqCategory' } | (
      { __typename?: 'FaqItem' }
      & Pick<FaqItem, 'id' | 'title' | 'url'>
      & { image?: Maybe<(
        { __typename?: 'Image' }
        & Pick<Image, 'id' | 'filename' | 'fullpath'>
      )> }
    ) | (
      { __typename?: 'Page' }
      & Pick<Page, 'id' | 'title' | 'url'>
      & { image?: Maybe<(
        { __typename?: 'Image' }
        & Pick<Image, 'id' | 'filename' | 'fullpath'>
      )> }
    ) | (
      { __typename?: 'Product' }
      & Pick<Product, 'id' | 'name' | 'url'>
      & { image?: Maybe<(
        { __typename?: 'Image' }
        & Pick<Image, 'id' | 'filename' | 'fullpath'>
      )> }
    ) | { __typename?: 'Sheet' } | { __typename?: 'Stylist' }> }
  )> }
);

export type ImageFragment = (
  { __typename?: 'Image' }
  & Pick<Image, 'id' | 'filename' | 'fullpath'>
);

export type EdgeBandsQueryVariables = Exact<{
  sku: Scalars['String']['input'];
  defaultLanguage: Scalars['String']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Array<AggregationInput> | AggregationInput>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type EdgeBandsQuery = (
  { __typename?: 'FrontendQuery' }
  & { edgeBandsQuery: (
    { __typename?: 'PublicEdgeBandIndexType' }
    & { aggregations: Array<(
      { __typename?: 'Aggregation' }
      & Pick<Aggregation, 'label' | 'value'>
      & { options: Array<(
        { __typename?: 'AggregationOption' }
        & Pick<AggregationOption, 'value' | 'label' | 'count'>
      )> }
    )>, available: (
      { __typename?: 'PublicEdgeBandConnection' }
      & Pick<PublicEdgeBandConnection, 'totalCount'>
      & { pageInfo: (
        { __typename?: 'PageInfo' }
        & Pick<PageInfo, 'hasNextPage'>
      ), edges?: Maybe<Array<(
        { __typename?: 'PublicEdgeBandEdge' }
        & { node: (
          { __typename?: 'PublicEdgeBand' }
          & Pick<PublicEdgeBand, 'id' | 'parentId' | 'sku' | 'name' | 'thickness' | 'width' | 'minOrderLength' | 'price'>
          & { image?: Maybe<(
            { __typename?: 'Image' }
            & Pick<Image, 'id' | 'filename' | 'fullpath'>
          )> }
        ) }
      )>> }
    ), matching: Array<(
      { __typename?: 'PublicEdgeBand' }
      & Pick<PublicEdgeBand, 'id' | 'parentId' | 'sku' | 'name' | 'thickness' | 'width' | 'minOrderLength' | 'price'>
      & { image?: Maybe<(
        { __typename?: 'Image' }
        & Pick<Image, 'id' | 'filename' | 'fullpath'>
      )> }
    )> }
  ) }
);

export type PublicEdgeBandFragment = (
  { __typename?: 'PublicEdgeBand' }
  & Pick<PublicEdgeBand, 'id' | 'parentId' | 'sku' | 'name' | 'thickness' | 'width' | 'minOrderLength' | 'price'>
  & { image?: Maybe<(
    { __typename?: 'Image' }
    & Pick<Image, 'id' | 'filename' | 'fullpath'>
  )> }
);

export const ImageFragmentDoc = gql`
    fragment Image on Image {
  id
  filename
  fullpath
}
    `;
export const PublicEdgeBandFragmentDoc = gql`
    fragment PublicEdgeBand on PublicEdgeBand {
  id
  parentId
  sku
  name
  thickness
  width
  image {
    ...Image
  }
  minOrderLength
  price
}
    ${ImageFragmentDoc}`;
export const SubmitAiProjectMutationDocument = gql`
    mutation SubmitAIProjectMutation($input: SubmitAIProjectInput!) {
  submitAIProject(input: $input) {
    project {
      id
    }
  }
}
    `;
export type SubmitAiProjectMutationMutationFn = Apollo.MutationFunction<SubmitAiProjectMutationMutation, SubmitAiProjectMutationMutationVariables>;
export type SubmitAiProjectMutationMutationResult = Apollo.MutationResult<SubmitAiProjectMutationMutation>;
export type SubmitAiProjectMutationMutationOptions = Apollo.BaseMutationOptions<SubmitAiProjectMutationMutation, SubmitAiProjectMutationMutationVariables>;
export const RelatedDiyProjectsDocument = gql`
    query RelatedDiyProjects($after: String, $first: Int, $before: String, $last: Int, $sku: String!, $defaultLanguage: String!) {
  relatedDiyProjects(
    after: $after
    first: $first
    before: $before
    last: $last
    sku: $sku
    defaultLanguage: $defaultLanguage
  ) {
    edges {
      node {
        id
        title
        images {
          ...Image
        }
        url
        metaDescription
      }
    }
  }
}
    ${ImageFragmentDoc}`;
export type RelatedDiyProjectsQueryResult = Apollo.QueryResult<RelatedDiyProjectsQuery, RelatedDiyProjectsQueryVariables>;
export const MiniSearchDocument = gql`
    query MiniSearch($query: String!, $defaultLanguage: String!) {
  miniSearch(query: $query, defaultLanguage: $defaultLanguage) {
    name
    code
    items {
      ... on Page {
        id
        title
        url
        image {
          ...Image
        }
      }
      ... on Product {
        id
        name
        url
        image {
          ...Image
        }
      }
      ... on Category {
        id
        name
        url
        image {
          ...Image
        }
      }
      ... on DIYProject {
        id
        title
        url
        images {
          ...Image
        }
      }
      ... on FaqItem {
        id
        title
        url
        image {
          ...Image
        }
      }
    }
  }
}
    ${ImageFragmentDoc}`;
export type MiniSearchQueryResult = Apollo.QueryResult<MiniSearchQuery, MiniSearchQueryVariables>;
export const EdgeBandsDocument = gql`
    query EdgeBands($sku: String!, $defaultLanguage: String!, $query: String, $filter: [AggregationInput!], $after: String, $first: Int, $before: String, $last: Int) {
  edgeBandsQuery(
    sku: $sku
    defaultLanguage: $defaultLanguage
    query: $query
    filter: $filter
    after: $after
    first: $first
    before: $before
    last: $last
  ) {
    aggregations {
      label
      value
      options {
        value
        label
        count
      }
    }
    available {
      pageInfo {
        hasNextPage
      }
      totalCount
      edges {
        node {
          ...PublicEdgeBand
        }
      }
    }
    matching {
      ...PublicEdgeBand
    }
  }
}
    ${PublicEdgeBandFragmentDoc}`;
export type EdgeBandsQueryResult = Apollo.QueryResult<EdgeBandsQuery, EdgeBandsQueryVariables>;